import React, { useEffect } from "react";
import { Box } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export const BackToTop = () => {
  useEffect(() => {
    if (window) {
      window.onscroll = function () {
        backToTopButton();
      };
    }
  });

  function backToTopButton() {
    var ele = document.getElementById("back-to-top");
    if (ele) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        ele.style.visibility = "visible";
      } else {
        ele.style.visibility = "hidden";
      }
    }
  }

  return (
    <Box
      id="back-to-top"
      sx={{
        visibility: "hidden",
        position: "fixed",
        bottom: 100,
        right: 20,
        borderRadius: "6px",
        backgroundColor: (theme) => theme.palette.primary.main,
        cursor: "pointer",

        display: "flex",
        justifyContent: "center",
        padding: "0.5rem",

        transition: "all 0.5s ease",

        zIndex: "10",

        "&:hover": {
          transform: "rotate(45deg)",
        },

        ":hover > svg": {
          transform: "rotate(-45deg)",
        },
      }}
      onClick={() => window.scrollTo(0, 0)}
    >
      <ArrowUpwardIcon
        sx={{
          color: "#fff",
          transition: "all 0.5s ease",
          width: "20px",
          height: "20px",
        }}
      />
    </Box>
  );
};
